import { AxiosResponse, AxiosError } from 'axios';
import { login, logout, updateToken } from '../../redux/auth/authSlice';
import { clearInvestmentData } from '../../redux/project/investmentSlice';
import { store } from '../../redux/store';

// let dispatch

// export const injectDispatch = _dispatch => {
//   dispatch = _dispatch
// }

export const responseInterceptor = async (response: AxiosResponse) => {
  const endPoint = response?.request?.responseURL.split('/').pop();
  if (endPoint === 'login') {
    const token = response.data.accessToken;
    store.dispatch(login({ token }));
    return response;
  }
  const token = response.headers?.['authorization'];
  store.dispatch(updateToken({ token }));
  return response;
};

export const responseErrorInterceptor = async (error: AxiosError) => {
  // If token is expired (401 error), log out the user
  console.log('error res');

  if (error.response?.status === 401) {
    store.dispatch(clearInvestmentData());
    store.dispatch(logout());
  }
  return Promise.reject(error);
};
